export default {
  cms: {
    dev: {
      web: {
        AboutUs: 'About Us',
        ContactUs: 'Contact Us',
        DeliveryMode: 'Delivery Mode',
        FrequentlyQuestions: 'Frequently Questions',
        LegalDeclarations: 'Legal Declarations',
        PrivacyClauses: 'Privacy Clauses',
        TermsConditions: 'Terms Conditions',
        JoinUs: 'Join Us',
        Title: 'Title',
        Category: 'Category',
        SimpleDscription: 'Simple Dscription',
        ProductCode: 'Product Code',
        ProductName: 'Product Name',
        CategoryName: 'Category Name',
        PicUrl: 'Pic Upload',
        JobName: 'Job Name',
        WorkingPlace: 'Working Place',
        JobDescription: 'Job Description',
        TipsTheme: 'Tips Theme',
        Tips: 'Tips',
        Status: 'Status',
        // 展厅
        Introduce: 'Introduce',
        PicUpload: 'Pic Upload',
        RoomName: 'Room Name',
        Address: 'Address',
        Mobile: 'Mobile',
        Fax: 'Fax',
        ManagerName: 'Manager Name',
        ManagerTel: 'Manager Tel',
        SalesMan: 'Salesman',
        SalesmanName: 'Salesman Name',
        SalesmanTel: 'Salesman Tel',
        RoomTitleCannotBeEmpty: 'Room Title Can not Be Empty',
        IntroduceCannotBeEmpty: 'Introduce Can not Be Empty',
        PicCannotBeEmpty: 'Pic Can not Be Empty',
        RoomNameCannotBeEmpty: 'Room Name Can Not Be Empty',
        TelphoneCannotBeEmpty: 'Telphone Can Not Be Empty',
        AddressCannotBeEmpty: 'Address Can Not Be Empty',
        ManagerNameCannotBeEmpty: 'Manager Name Can Not Be Empty',
        ManagerTelCannotBeEmpty: 'Manager Tel Can Not Be Empty'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/cms/web.js